import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class Separator {

  isCallable () {
    return window.innerWidth > 1024
  }

  init () {

    gsap.registerPlugin(ScrollTrigger)

    const elements = document.querySelectorAll('hr')

    elements.forEach(element => {
      gsap.fromTo(element, {
        width: '0%'
      }, {
        width: '100%',
        scrollTrigger: {
          trigger: element,
          start: 'top bottom-=100',
          end: 'bottom center',
          toggleActions: 'play none none reverse'
        }
      })
    })

  }
}
